import script from "./onlineMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./onlineMessage.vue?vue&type=script&setup=true&lang=js"

import "./onlineMessage.vue?vue&type=style&index=0&id=87fd0fea&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87fd0fea"]])

export default __exports__